import { Trans, useTranslation } from 'react-i18next';
import Button from '@/components/Button';
import Spinner from '@/components/Spinner';
import styles from './ConnectingPanel.module.scss';

interface ConnectingPanelProps {
  onCancel: () => void;
  providerName: string;
}

const ConnectingPanel = ({ onCancel, providerName }: ConnectingPanelProps) => {
  const { t } = useTranslation(['onboarding']);

  return (
    <section className={styles.card}>
      <h2 className={styles.title}>
        {t('onboarding:kycSelection.connecting.title')}
      </h2>
      <div className={styles.loaderWrap}>
        <Spinner />
      </div>
      <div className={styles.desc}>
        <Trans
          i18nKey="onboarding:kycSelection.connecting.redirecting"
          values={{ provider: providerName }}
          components={[<strong key="provider" />]}
        />
      </div>
      <Button variant="text" onClick={onCancel} className={styles.cancel}>
        {t('onboarding:kycSelection.connecting.cancel')}
      </Button>
    </section>
  );
};

export default ConnectingPanel;
